import React, { useState, ReactNode } from 'react';
import { Layout as AntLayout, Grid } from 'antd';
import { HomeOutlined, AppstoreOutlined, TeamOutlined, EnvironmentOutlined, ShopOutlined, SettingOutlined, UserSwitchOutlined, BankOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AppHeader from './AppHeader';
import Sidebar from './Sidebar';

const { Content, Footer } = AntLayout;
const { useBreakpoint } = Grid;

const Layout = ({ children }: { children: ReactNode }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  if (!user) {
    return <>{children}</>;
  }

  const menuItems = [
    { key: 'dashboard', icon: <HomeOutlined />, label: <Link to="/">Trang chủ</Link> },
    { key: 'assets', icon: <AppstoreOutlined />, label: <Link to="/assets">Tài sản</Link> },
    { key: 'categories', icon: <SettingOutlined />, label: <Link to="/asset-categories">Danh mục</Link> },
    { key: 'employees', icon: <TeamOutlined />, label: <Link to="/employees">Nhân viên</Link> },
    { key: 'locations', icon: <EnvironmentOutlined />, label: <Link to="/locations">Vị trí</Link> },
    { key: 'suppliers', icon: <ShopOutlined />, label: <Link to="/suppliers">Nhà cung cấp</Link> },
  ];

  if (user.role === 'super_admin') {
    menuItems.push(
      { key: 'companies', icon: <BankOutlined />, label: <Link to="/companies">Công ty</Link> },
      { key: 'users', icon: <UserSwitchOutlined />, label: <Link to="/users">Người dùng</Link> },
    );
  }

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} />
      <AntLayout>
        <AppHeader onMenuClick={() => setCollapsed(c => !c)} collapsed={collapsed} />
        <Content style={{ padding: '32px 16px 0 16px', background: '#f5f6fa', flex: 1 }}>
          <div style={{ maxWidth: 1200, margin: '0 auto' }}>{children}</div>
        </Content>
        <Footer style={{ textAlign: 'center', background: '#fff' }}>
          Phần mềm được phát triển bởi Tt - Version 1.0.<br/>
          Bản quyền thuộc về Công ty Đông Dương. © 2025. Mọi quyền được bảo lưu.
        </Footer>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout; 